// src/components/CargaMasiva/PdfPreviewDialog.js
//
// Dialog con iframe para preview de PDFs ya generados.
// Recibe un Blob (ya descargado) y muestra el PDF embebido.
// Al cerrar libera el blob URL.

import React, { useEffect, useState } from 'react';
import {
    Dialog, DialogTitle, DialogContent, IconButton, Box, Typography, Tooltip, Button,
} from '@mui/material';
import {
    Close as CloseIcon, Download as DownloadIcon, OpenInNew as OpenInNewIcon,
} from '@mui/icons-material';

const COLOR = '#6a1b9a';

export default function PdfPreviewDialog({ open, blob, titulo, filename, onClose }) {
    const [url, setUrl] = useState('');

    useEffect(() => {
        if (blob && open) {
            const u = URL.createObjectURL(blob);
            setUrl(u);
            return () => { URL.revokeObjectURL(u); };
        }
        setUrl('');
    }, [blob, open]);

    const descargar = () => {
        if (!url) return;
        const a = document.createElement('a');
        a.href = url;
        a.download = filename || 'documento.pdf';
        a.click();
    };

    const abrirNuevaPestana = () => {
        if (url) window.open(url, '_blank');
    };

    return (
        <Dialog
            open={open} onClose={onClose}
            maxWidth={false}
            PaperProps={{ sx: { width: '90vw', height: '92vh', borderRadius: '4px' } }}
        >
            <DialogTitle sx={{
                bgcolor: COLOR, color: 'white', py: 1, px: 2,
                display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            }}>
                <Typography sx={{ fontWeight: 600, fontSize: '1rem' }}>{titulo || 'Documento'}</Typography>
                <Box sx={{ display: 'flex', gap: 0.5 }}>
                    <Tooltip title="Descargar">
                        <IconButton size="small" onClick={descargar} sx={{ color: 'white' }}><DownloadIcon fontSize="small" /></IconButton>
                    </Tooltip>
                    <Tooltip title="Abrir en nueva pestaña">
                        <IconButton size="small" onClick={abrirNuevaPestana} sx={{ color: 'white' }}><OpenInNewIcon fontSize="small" /></IconButton>
                    </Tooltip>
                    <Tooltip title="Cerrar">
                        <IconButton size="small" onClick={onClose} sx={{ color: 'white' }}><CloseIcon fontSize="small" /></IconButton>
                    </Tooltip>
                </Box>
            </DialogTitle>
            <DialogContent sx={{ p: 0, bgcolor: '#f5f5f5' }}>
                {url ? (
                    <iframe
                        title={titulo || 'pdf'}
                        src={url}
                        style={{ width: '100%', height: '100%', border: 'none', display: 'block' }}
                    />
                ) : (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%', flexDirection: 'column', gap: 2 }}>
                        <Typography color="text.secondary">Cargando PDF...</Typography>
                        <Button variant="outlined" onClick={onClose}>Cerrar</Button>
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    );
}
